import React from "react";
import { Container, InfoText } from "./info-container.styled";
import amountToFixed from "@/helper/amountToFixed";

export default function InfoContainer({ cashOrCardValue }) {
    return (
        <Container>
            <InfoText>
                Fondos insuficientes. Debe pagar RD{" "}
                <strong>{`RD$ ${amountToFixed(cashOrCardValue, 2)}`}</strong> con otro método a continuacion.
            </InfoText>
        </Container>
    );
};

